'use client'

import { useI18n } from '@shared/config/i18n'
import { formatKrwAmount } from '@shared/utils'
import { memo } from 'react'

import { Box, HStack, Typography, VStack } from '@podo-app/design-system-temp'

type Props = {
  originalPrice: number
  discountPrice: number
  totalPrice: number
}

const SmartTalkTrialPaymentSummary = memo(({ originalPrice, discountPrice, totalPrice }: Props) => {
  const { effectiveLocale, t } = useI18n()

  return (
    <VStack className="p-5 bg-gray-100 border border-gray-200 rounded-lg gap-4">
      <VStack className="gap-1">
        <HStack className="justify-between">
          <Typography size="body1" className="text-gray-400 font-normal">
            {t('payment.summary.productAmount')}
          </Typography>
          <Typography size="body1" className="font-normal">
            {formatKrwAmount(originalPrice, effectiveLocale)}
          </Typography>
        </HStack>

        <HStack className="justify-between">
          <Typography size="body1" className="text-gray-400 font-normal">
            {t('payment.summary.firstComeDiscount')}
          </Typography>
          <Typography size="body1" className="font-normal">
            {t('payment.summary.discountAmount', { amount: formatKrwAmount(discountPrice, effectiveLocale) })}
          </Typography>
        </HStack>
      </VStack>

      <Box className="h-px bg-gray-200" />

      <VStack className="gap-1">
        <HStack className="justify-between">
          <Typography size="h2">{t('payment.summary.totalAmount')}</Typography>
          <Typography size="h2">{formatKrwAmount(totalPrice, effectiveLocale)}</Typography>
        </HStack>
      </VStack>
    </VStack>
  )
})

export default SmartTalkTrialPaymentSummary
